module.exports = __webpack_public_path__ + "img/w47.46660df8.svg";